module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.b351bd62abcd96e924d9.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module id = ../../../../material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module chunks = 2